import { useSearchParams } from 'react-router-dom'
import { RATE_APP_SEARCH_PARAMETER } from '../consts'
import { useEffect } from 'react'

interface Props {
  loggedIn: boolean
  openAppRating: () => void
}

/**
 * A hook to handle the app rating when the url has rate-app parameter
 */
const useHandleAppRatingUrlParameter = ({ loggedIn, openAppRating }: Props): void => {
  const [searchParams] = useSearchParams()
  const rateAppUrlParameterAvailable = Boolean(searchParams.get(RATE_APP_SEARCH_PARAMETER))
  const rateAppUrlParameterSavedBeforeLogin = localStorage.getItem(RATE_APP_SEARCH_PARAMETER)

  useEffect(() => {
    if (!rateAppUrlParameterAvailable && !rateAppUrlParameterSavedBeforeLogin) return

    /* handle url parameter */
    if (rateAppUrlParameterAvailable) {
      if (loggedIn) {
        openAppRating()
        return
      }
      localStorage.setItem(RATE_APP_SEARCH_PARAMETER, rateAppUrlParameterAvailable ? 'true' : 'false')
      return
    }

    /* handle local storage item */
    if (loggedIn && rateAppUrlParameterSavedBeforeLogin === 'true') {
      openAppRating()
      localStorage.removeItem(RATE_APP_SEARCH_PARAMETER)
    }
  }, [loggedIn, openAppRating, rateAppUrlParameterAvailable, rateAppUrlParameterSavedBeforeLogin])
}

export default useHandleAppRatingUrlParameter
